import React from "react";
import { observer } from "mobx-react";
import copilotStore, { TABLE_PAGE_SIZES } from "Stores/copilotStore";
import PaginationComponent from "Components/common/PaginationComponent";
import ProspectTable from "./ProspectTable";

const TableSidePanel = observer(() => {
  const { tableId } = copilotStore.sidePanel;
  const table = copilotStore.tables.get(tableId);
  if (!table) return null;

  const totalPages = Math.max(1, Math.ceil(table.totalCount / table.pageSize));

  return (
    <>
      <div className="copilotTablePanel">
        <div className="copilotTablePanel__header">
          <div className="copilotTablePanel__headMeta">
            <div className="copilotTablePanel__title">{table.title}</div>
            <div className="copilotTablePanel__count">
              {table.totalCount.toLocaleString()} records
            </div>
          </div>
          <span
            className="material-icons-outlined copilotTablePanel__close"
            onClick={copilotStore.closeTablePanel}
          >
            close
          </span>
        </div>
        <div className="copilotTablePanel__body">
          {table.stale ? (
            <div className="copilotTablePanel__stale">
              <i className="material-icons-outlined">history</i>
              <div className="copilotTablePanel__staleTitle">
                Results no longer available
              </div>
              <div className="copilotTablePanel__staleText">
                This table is from an earlier chat and its results aren&apos;t
                kept once the chat ends. Ask Copilot to run the search again to
                see and act on these results.
              </div>
            </div>
          ) : (
            <ProspectTable table={table} tableId={tableId} />
          )}
        </div>
        {!table.stale && (
          <div className="copilotTablePanel__footer">
            <div className="copilotTablePanel__pageSize">
              <span className="copilotTablePanel__pageSizeLabel">Rows</span>
              {TABLE_PAGE_SIZES.map(size => (
                <button
                  type="button"
                  key={size}
                  className={`copilotTablePanel__pageSizeBtn ${
                    table.pageSize === size ? "selected" : ""
                  }`}
                  disabled={table.loading}
                  onClick={() => copilotStore.setTablePageSize(tableId, size)}
                >
                  {size}
                </button>
              ))}
            </div>
            <PaginationComponent
              totalPages={totalPages}
              currentPage={table.currentPage}
              loading={table.loading}
              callback={({ selected }) =>
                copilotStore.fetchTablePage(tableId, selected + 1)
              }
            />
          </div>
        )}
      </div>
    </>
  );
});

export default TableSidePanel;
